(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6346],{

/***/ 59884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_lib_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63787);
/* harmony import */ var antd_lib_modal_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(antd_lib_modal_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var antd_lib_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18397);
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41100);
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(antd_lib_button_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var antd_lib_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92743);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72995);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25427);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var TryModal = function TryModal(props, ref) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    error: false,
    visible: false
  }),
      modalInfo = _useState[0],
      setModalInfo = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    setIsMobile((0,utils_index__WEBPACK_IMPORTED_MODULE_6__/* .platform */ .Jv)().mobile);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useImperativeHandle)(ref, function () {
    return {
      open: function open(error, visible) {
        return setModalInfo({
          error: error,
          visible: visible
        });
      }
    };
  });

  var onClose = function onClose() {
    return setModalInfo(_objectSpread(_objectSpread({}, modalInfo), {}, {
      visible: false
    }));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(antd_lib_modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    onCancel: onClose,
    closable: isMobile ? false : true,
    visible: modalInfo.visible,
    footer: null,
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().modal), modalInfo.error && (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().errModal)),
    children: [modalInfo.error ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().errTitle),
        children: "\u63D0\u4EA4\u5931\u8D25"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().errText),
        children: "\u51FA\u4E86\u70B9\u95EE\u9898\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5\u3002"
      })]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
        src: '/v2/images/success.svg',
        alt: "success",
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().successIcon)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().successText),
        children: ["\u60A8\u7684\u4FE1\u606F\u5DF2\u7ECF\u63D0\u4EA4\u6210\u529F ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), " \u6211\u4EEC\u4F1A\u5C3D\u5FEB\u4E0E\u60A8\u53D6\u5F97\u8054\u7CFB\uFF01"]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btn), modalInfo.error && (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().error)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd_lib_button__WEBPACK_IMPORTED_MODULE_9__["default"], {
        type: "primary",
        onClick: onClose,
        children: "\u77E5\u9053\u4E86"
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.forwardRef(TryModal));

/***/ }),

/***/ 89280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_try; }
});

// EXTERNAL MODULE: ./node_modules/antd/lib/input/style/index.js
var style = __webpack_require__(40861);
// EXTERNAL MODULE: ./node_modules/antd/lib/input/index.js
var input = __webpack_require__(38706);
// EXTERNAL MODULE: ./node_modules/antd/lib/button/style/index.js
var button_style = __webpack_require__(41100);
// EXTERNAL MODULE: ./node_modules/antd/lib/button/index.js
var lib_button = __webpack_require__(92743);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/antd/lib/form/style/index.js
var form_style = __webpack_require__(42213);
// EXTERNAL MODULE: ./node_modules/antd/lib/form/index.js
var lib_form = __webpack_require__(76290);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(25427);
// EXTERNAL MODULE: ./src/action/index.ts + 2 modules
var action = __webpack_require__(37121);
// EXTERNAL MODULE: ./src/components/layout/index.tsx + 6 modules
var layout = __webpack_require__(16569);
// EXTERNAL MODULE: ./src/utils/statics/index.ts
var statics = __webpack_require__(86209);
// EXTERNAL MODULE: ./src/pages/try/index.module.scss
var index_module = __webpack_require__(48352);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/utils/try.ts
var getChromeVersion = function getChromeVersion() {
  var pieces = navigator.userAgent.match(/Chrom(?:e|ium)\/([0-9]+)\.([0-9]+)\.([0-9]+)\.([0-9]+)/);

  if (pieces === null || pieces.length !== 5) {
    return undefined;
  }

  pieces = pieces.map(function (piece) {
    return parseInt(piece, 10);
  });
  return pieces[1];
};

var getEdgeVersion = function getEdgeVersion() {
  var pieces = navigator.userAgent.match(/Ed(?:g)\/([0-9]+)\.([0-9]+)\.([0-9]+)/);

  if (pieces == null || pieces.length < 4) {
    return undefined;
  }

  pieces = pieces.map(function (piece) {
    return parseInt(piece, 10);
  });
  return pieces[1];
};

var isShowWebRtc = function isShowWebRtc() {
  var ua = navigator.userAgent;
  var isChrome = /(?:Chrome|CriOS)/.test(ua) && !(ua.indexOf('Edg') > -1);
  var isEdge = ua.indexOf('Edg') > -1;
  var isShow = false;

  if (isChrome) {
    var chromeVersion = getChromeVersion();

    if (chromeVersion && chromeVersion >= 72) {
      isShow = true;
    }
  } else if (isEdge) {
    var edgeVersion = getEdgeVersion();

    if (edgeVersion && edgeVersion >= 80) {
      isShow = true;
    }
  }

  return isShow;
};
;// CONCATENATED MODULE: ./src/constants/try/index.ts
var qrCode = 'https://devcdn.xylink.com/xylink_website_doc/images/try/%E7%AB%8B%E5%8D%B3%E8%AF%95%E7%94%A82%E5%80%8D%E4%BA%8C%E7%BB%B4%E7%A0%81.png';
var clientList = [{
  name: '试用Windows客户端',
  platform: 'desktop_pc',
  track: {
    category: 'Windows下载量-try'
  },
  key: 'pc',
  show: true,
  type: 'WINDOWS_TRIAL'
}, {
  name: '试用Mac客户端',
  platform: 'desktop_mac',
  track: {
    category: 'Mac下载量-try'
  },
  key: 'mac',
  show: true,
  type: 'MAC_TRIAL'
}, {
  name: '试用Web会议',
  downloadUrl: 'https://cdn.xylink.com/webrtc/web/index.html?number=MTg4MTg4#/',
  track: {
    category: 'webRTC',
    action: '试用'
  },
  key: 'webRTC',
  show: true
}];
var formList = [{
  name: 'contactName',
  placeholder: '您的姓名',
  rules: [{
    required: true,
    message: '请填写您的姓名'
  }]
}, {
  name: 'contactPhone',
  placeholder: '联系电话',
  rules: [{
    required: true,
    message: '请填写您的联系电话'
  }, {
    pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
    message: '填写的电话号码格式不正确'
  }]
}, {
  name: 'contactEmail',
  placeholder: '您的邮箱',
  rules: [{
    required: true,
    message: '请填写您的邮箱'
  }, {
    type: 'email',
    message: '您填写的邮箱格式不正确'
  }]
}, {
  name: 'contactEnterpriseName',
  placeholder: '公司名称',
  rules: [{
    required: true,
    message: '请填写您的公司名称'
  }]
}, {
  name: 'customerDemand',
  placeholder: '您的需求',
  rules: [{
    required: true,
    message: '请填写您的需求'
  }],
  isTextArea: true,
  maxLength: 200,
  className: 'textArea'
}];

// EXTERNAL MODULE: ./src/components/tryModal/index.tsx
var tryModal = __webpack_require__(59884);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/try/index.tsx











function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var FormItem = lib_form/* default.Item */.Z.Item;

var Try = function Try() {
  var _useState = (0,react.useState)(false),
      submitStatus = _useState[0],
      setSubmitStatus = _useState[1];

  var _useState2 = (0,react.useState)([]),
      appList = _useState2[0],
      setAppList = _useState2[1];

  var _Form$useForm = lib_form/* default.useForm */.Z.useForm(),
      _Form$useForm2 = (0,slicedToArray/* default */.Z)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState3 = (0,react.useState)('ios'),
      appType = _useState3[0],
      setAppType = _useState3[1];

  var modalRef = (0,react.useRef)(null);

  var getPlatformUrl = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var versionList;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              versionList = (0,toConsumableArray/* default */.Z)(clientList).map(function (item) {
                if (item.platform) {
                  return action/* actionServer.getClientInfo */.$.getClientInfo(item.platform);
                }

                return item;
              });
              _context.next = 3;
              return Promise.all(versionList).then(function (list) {
                list.forEach(function (item, index) {
                  var appUrl = item.appUrl,
                      platform = item.platform;
                  var originPlatform = clientList[index].platform;
                  var platKey = clientList[index].key;

                  if (originPlatform && platform === originPlatform) {
                    clientList[index].downloadUrl = appUrl;
                  }

                  if (platKey === 'webRTC') {
                    clientList[index].show = isShowWebRtc();
                  }
                });
              });

            case 3:
              setAppList(clientList);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getPlatformUrl() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    getPlatformUrl();
    var isIos = (0,utils/* platform */.Jv)().ios;
    setAppType(isIos ? 'ios' : 'android');
  }, []);

  var onFinish = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(values) {
      var result, _modalRef$current, _modalRef$current$ope, _modalRef$current2, _modalRef$current2$op;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setSubmitStatus(true);

              if (values) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              values.applicationType = '1';
              _context2.next = 6;
              return action/* action.submit */.a.submit(values, 'try');

            case 6:
              result = _context2.sent;

              if (!result) {
                (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 ? void 0 : (_modalRef$current$ope = _modalRef$current.open) === null || _modalRef$current$ope === void 0 ? void 0 : _modalRef$current$ope.call(_modalRef$current, false, true);
              } else {
                (_modalRef$current2 = modalRef.current) === null || _modalRef$current2 === void 0 ? void 0 : (_modalRef$current2$op = _modalRef$current2.open) === null || _modalRef$current2$op === void 0 ? void 0 : _modalRef$current2$op.call(_modalRef$current2, true, true);
              }

              form.resetFields();
              setSubmitStatus(false);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onFinish(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); // 埋点


  var trackEvent = function trackEvent(params, type) {
    (0,statics/* downloadCount */.Q)({}, _objectSpread({}, params));

    if (type) {
      action/* actionServer.statisticsSearch */.$.statisticsSearch(type);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout/* default */.Z, {
    layoutClass: (index_module_default()).layout,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "\u7ACB\u5373\u8BD5\u7528"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).banner,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).title,
        children: "\u7ACB\u5373\u8BD5\u7528"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).desc,
        children: "\u4F53\u9A8C\u4EBA\u4EBA\u90FD\u4F1A\u7528\u7684\u4E91\u89C6\u9891\u4F1A\u8BAE"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).phone,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).container,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).left,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            children: "\u624B\u673AApp"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()((index_module_default()).desc, 'for-pc'),
            children: "2\u79D2\u7EC4\u4F1A\uFF0C1\u79D2\u5165\u4F1A\uFF0C\u968F\u65F6\u968F\u5730\u53C2\u52A0\u4E91\u89C6\u9891\u4F1A\u8BAE"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((index_module_default()).desc, 'for-mobile'),
            children: ["2\u79D2\u7EC4\u4F1A\uFF0C1\u79D2\u5165\u4F1A", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u968F\u65F6\u968F\u5730\u53C2\u52A0\u4E91\u89C6\u9891\u4F1A\u8BAE"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((index_module_default()).qrCode, 'for-pc'),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: qrCode,
              alt: ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default()).platform,
              children: "\u626B\u7801\u8BD5\u7528\uFF08iOS\uFF0CAndroid\uFF09"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((index_module_default()).app, 'for-mobile'),
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(lib_button["default"], {
              type: "primary",
              href: "https://a.app.qq.com/o/simple.jsp?pkgname=com.ainemo.dragoon",
              children: ["\u8BD5\u7528", appType === 'ios' ? 'iOS' : 'Android', "\u5BA2\u6237\u7AEF"]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default())["other-app"],
              children: ["\u540C\u65F6\u652F\u6301", appType !== 'ios' ? 'iOS' : 'Android', "\u7248\u672C"]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).right,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            className: 'for-pc',
            src: "https://devcdn.xylink.com/xylink_website_doc/images/try/app%E5%88%87%E5%9B%BE.png",
            alt: ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            className: 'for-mobile',
            src: "https://devcdn.xylink.com/xylink_website_doc/images/try/mobile/%E6%96%B0%E7%9A%84%E7%AB%8B%E5%8D%B3%E8%AF%95%E7%94%A8%E7%A7%BB%E5%8A%A8%E7%89%88-app%E9%85%8D%E5%9B%BE.png",
            alt: ""
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).client,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).container,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).left,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "https://devcdn.xylink.com/xylink_website_doc/images/try/%E6%96%B0%E7%9A%84%E7%AB%8B%E5%8D%B3%E8%AF%95%E7%94%A8%E7%A7%BB%E5%8A%A8%E7%89%88-%E7%94%B5%E8%84%91%E7%AB%AF%E9%85%8D%E5%9B%BE.png",
            alt: ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()((index_module_default()).tryDesc, 'for-mobile'),
            children: "Windows\u548CMac\u7535\u8111\u5BA2\u6237\u7AEF\u8BF7\u8BBF\u95EE\u7535\u8111\u7248\u8BD5\u7528"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).right,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            children: "\u7535\u8111\u5BA2\u6237\u7AEF"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()((index_module_default()).desc, 'for-pc'),
            children: "\u8D34\u8FD1\u529E\u516C\u573A\u666F\uFF0C\u66F4\u9AD8\u54C1\u8D28\u7684\u97F3\u89C6\u9891\u4F53\u9A8C\uFF0C\u66F4\u4E30\u5BCC\u7684\u4F1A\u8BAE\u7BA1\u7406\u529F\u80FD"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((index_module_default()).desc, 'for-mobile'),
            children: ["\u8D34\u8FD1\u529E\u516C\u573A\u666F", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u66F4\u9AD8\u54C1\u8D28\u7684\u97F3\u89C6\u9891\u4F53\u9A8C", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u66F4\u4E30\u5BCC\u7684\u4F1A\u8BAE\u7BA1\u7406\u529F\u80FD"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()('for-pc'),
            children: appList.map(function (item) {
              return item.show ? /*#__PURE__*/(0,jsx_runtime.jsx)(lib_button["default"], {
                onClick: function onClick() {
                  return trackEvent(item.track, item.type);
                },
                className: (index_module_default()).clientItem,
                type: "primary",
                size: "large",
                href: item.downloadUrl,
                children: item.name
              }, item.name) : null;
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).form,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).container,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).left,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            children: "\u786C\u4EF6\u7EC8\u7AEF"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()((index_module_default()).desc, 'for-pc'),
            children: "\u4E13\u4E1A\u7684\u667A\u80FD\u786C\u4EF6\u7EC8\u7AEF\uFF0C\u611F\u53D7\u5728\u4F1A\u8BAE\u5BA4\u91CC\u89C6\u9891\u6C9F\u901A\u7684\u6C89\u6D78\u4F53\u9A8C"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((index_module_default()).desc, 'for-mobile'),
            children: ["\u4E13\u4E1A\u7684\u667A\u80FD\u786C\u4EF6\u7EC8\u7AEF", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u611F\u53D7\u5728\u4F1A\u8BAE\u5BA4\u91CC\u89C6\u9891\u6C9F\u901A\u7684\u6C89\u6D78\u4F53\u9A8C"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: classnames_default()((index_module_default()).deviceImage, 'for-mobile'),
          src: "https://devcdn.xylink.com/xylink_website_doc/images/try/mobile/%E6%96%B0%E7%9A%84%E7%AB%8B%E5%8D%B3%E8%AF%95%E7%94%A8%E7%A7%BB%E5%8A%A8%E7%89%88-%E7%A1%AC%E4%BB%B6%E9%85%8D%E5%9B%BE.png",
          alt: ""
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(lib_form/* default */.Z, {
          form: form,
          className: (index_module_default()).formInfo,
          onFinish: onFinish,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).title,
            children: "\u7533\u8BF7\u8BD5\u7528\u786C\u4EF6\u7EC8\u7AEF"
          }), formList.map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(FormItem, {
              name: item.name,
              rules: item.rules,
              children: item.isTextArea ? /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default.TextArea */.Z.TextArea, {
                placeholder: item.placeholder,
                maxLength: item.maxLength,
                className: (index_module_default())[item.className]
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
                placeholder: item.placeholder
              })
            }, item.name);
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormItem, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib_button["default"], {
              type: "primary",
              htmlType: "submit",
              loading: submitStatus,
              children: submitStatus ? '提交中...' : '提交'
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(tryModal/* default */.Z, {
      ref: modalRef
    })]
  });
};

/* harmony default export */ var pages_try = (Try);

/***/ }),

/***/ 35262:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/try",
      function () {
        return __webpack_require__(89280);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72995:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"tryModal_border__px__o8KMt","border__px-before":"tryModal_border__px-before__msrcp","border__px-before1":"tryModal_border__px-before1__78VJP","border-children1":"tryModal_border-children1__zDNsw","border-children2":"tryModal_border-children2__iZRlT","for-mobile":"tryModal_for-mobile__rUFFH","for-pc":"tryModal_for-pc__HJ4i0","modal":"tryModal_modal__Clzhe","successText":"tryModal_successText__Gllz1","errTitle":"tryModal_errTitle__oNhim","errText":"tryModal_errText__3qXjX","successIcon":"tryModal_successIcon__YuSpW","btn":"tryModal_btn__Mt_um","error":"tryModal_error__PAYWB","errModal":"tryModal_errModal__OsgeI"};

/***/ }),

/***/ 48352:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"try_border__px__ri4Rh","border__px-before":"try_border__px-before__JETfE","border__px-before1":"try_border__px-before1__mcHbm","border-children1":"try_border-children1__q0aNP","border-children2":"try_border-children2__bMx8r","for-mobile":"try_for-mobile__zgZeZ","for-pc":"try_for-pc__Fp_me","container":"try_container__iTOy5","layout":"try_layout__lxKoC","banner":"try_banner___TkMQ","title":"try_title__14Cro","desc":"try_desc__plDQ3","phone":"try_phone__SYcDp","left":"try_left__vj1fc","qrCode":"try_qrCode___MiaJ","platform":"try_platform__WUPpr","right":"try_right__b8ymO","client":"try_client__I__xl","clientItem":"try_clientItem__qWn3s","form":"try_form__q8LMN","formInfo":"try_formInfo__l63DM","textArea":"try_textArea__XE1Iu","success":"try_success__EZjkH","successText":"try_successText___pjo5","successIcon":"try_successIcon__VkVeW","app":"try_app__hZ2sU","other-app":"try_other-app__0d_HU","tryDesc":"try_tryDesc___opMx","deviceImage":"try_deviceImage__A3seD"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1747,4662,2178,3528,9774,2888,179], function() { return __webpack_exec__(35262); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);